<app-expansion-panel-without-border [titre]="aptitude().nom" [item]="aptitude()">
  <app-chip [label]="aptitude().productions?.length ?? 0" size="badge" ngProjectAs="etat" />
  <div class="px-md flex flex-col">
    @for (production of aptitude().productions | trierPar: 'nom'; track production.id) {
      <app-production-item
        [cartographie]="cartographie()"
        [production]="production"
        [idAptitude]="aptitude().id"
        [peutModifier]="peutModifier()"
      />
    } @empty {
      <span class="paragraph-medium-medium text-content-secondary">
        Aucune production n’a été créée. Rendez-vous dans le Processus pour les créer.
      </span>
      <button class="mt-xs" (click)="navigateToProcessus()" hlmBtn variant="secondary">
        <ng-icon name="lucideArrowLeft" />
        Retourner au Processus
      </button>
    }
  </div>
</app-expansion-panel-without-border>
